package team.platforma.auth_domain.di

import org.koin.dsl.module
import team.platforma.auth_domain.UserUseCase
import team.platforma.auth_domain.use_cases.UserNetworkUseCase

val authDomainModule = module{
    single {
        UserUseCase(
            network = UserNetworkUseCase(get())
        )

    }
}